import { SDKManager } from "./SDKManager";

export class Utils {

    public static Lerp(start, end, amt) {
        return (1 - amt) * start + amt * end
    }

    public static Interpolate(input: number, inputMin: number, inputMax: number, outputMin: number = 0, outputMax: number = 1): number {
        var value = outputMin + (((input - inputMin) * (outputMax - outputMin)) / (inputMax - inputMin));
        return value;
    }

    public static GetParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

}

export class LocalDB {
    private static readonly gameKey: string;
    constructor(gameKey: string) {
        if (!LocalDB.gameKey) {
            (LocalDB.gameKey as any) = gameKey;
        }
    }

    public getItem<T>(key: string): T | null {
        if(SDKManager.local){
            try {
                const item = localStorage.getItem(`${LocalDB.gameKey}_${key}`);
                return item ? JSON.parse(item) : null;
            } catch (error) {
                console.error(`Error retrieving or parsing item with key: ${key}`, error);
                return null;
            }
        }
        else{
            try {
                const item = SDKManager.getItem(`${LocalDB.gameKey}_${key}`);
                return item ? JSON.parse(item) : null;
            } catch (error) {
                console.error(`Error retrieving or parsing item with key: ${key}`, error);
                return null;
            }
        }
    }

    public setItem<T>(key: string, value: T): void {
        if(SDKManager.local){
            localStorage.setItem(`${LocalDB.gameKey}_${key}`, JSON.stringify(value));
        }
        else{
            SDKManager.setItem(`${LocalDB.gameKey}_${key}`, JSON.stringify(value));
        }
    }
}